// src/pages/NewsPage.js

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ReactComponent as NewsIcon } from '../assets/icon-news.svg';

const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;

function NewsPage() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const jwt = localStorage.getItem('jwt');
    const fetchNews = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await axios.get(
          `${STRAPI_URL}/api/nieuws-items?sort=publication_date:desc&populate=featured_image`,
          { headers: { Authorization: `Bearer ${jwt}` } }
        );
        setNews(res.data.data);
      } catch (err) {
        setError('Het nieuws laden lukte niet. Probeer het opnieuw.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, []);

  if (loading) return <p>Nieuws wordt geladen...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="overview-page-grid">
      <main className="overview-main-content">
        <div className="overview-header">
          <h1>Nieuws</h1>
        </div>

        <p>Hier vind je alle nieuwsberichten. Simpel overzicht, klik door voor het volledige item.</p>

        <div className="doorloopje-list">
          {news.length > 0 ? news.map(item => {
            const imageUrl = item.featured_image?.formats?.thumbnail?.url || item.featured_image?.url;
            return (
              <Link to={`/nieuws-item/${item.slug}`} key={`news-${item.id}`} className="doorloopje-card">
                {imageUrl ? (
                  <img src={imageUrl} alt={item.title} className="card-icon" loading="lazy" />
                ) : (
                  <div className="card-icon"><NewsIcon /></div>
                )}
                <div className="card-text">
                  <h3>{item.title}</h3>
                  <p>{item.summary}</p>
                </div>
                <div className="card-arrow">></div>
              </Link>
            );
          }) : (
            <p>Geen nieuws gevonden.</p>
          )}
        </div>
      </main>

      {/* Geen sidebar navigatie nodig voor deze simpele layout */}
      <aside className="overview-sidebar">
        <h3>&nbsp;</h3>
      </aside>
    </div>
  );
}

export default NewsPage;
